import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { useLang } from '@/contexts/LangContext';
import api from '@/lib/api';

export default function LegalPage() {
  const { slug } = useParams();
  const { t, lang } = useLang();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/content/legal/${slug}`)
      .then(res => setPage(res.data))
      .catch(() => setPage(null))
      .finally(() => setLoading(false));
  }, [slug, lang]);

  if (loading) return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-16">
      <Skeleton className="h-10 w-1/2 mb-6" />
      <Skeleton className="h-6 w-full mb-3" />
      <Skeleton className="h-6 w-full mb-3" />
      <Skeleton className="h-6 w-3/4 mb-3" />
    </div>
  );

  if (!page) return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-16 text-center">
      <h1 className="text-2xl font-semibold mb-4">{lang === 'ar' ? 'الصفحة غير موجودة' : 'Page not found'}</h1>
      <Link to="/"><Button variant="outline" className="rounded-xl">{t('nav.home')}</Button></Link>
    </div>
  );

  return (
    <div data-testid="legal-page" className="py-10 sm:py-14">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8">
          <ArrowLeft className="h-4 w-4" /> {t('nav.home')}
        </Link>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="prose prose-sm sm:prose max-w-none prose-headings:text-foreground prose-p:text-muted-foreground prose-li:text-muted-foreground prose-strong:text-foreground"
          dangerouslySetInnerHTML={{ __html: page.content_html }}
        />
      </div>
    </div>
  );
}
